export const getBeacons = (state, ownProps) => {
  try {
    return state.beacons[state.device.device?.id] || [];
  } catch {
    return [];
  }
};
